import { mapGetters } from "vuex";
import { stringHelper } from "@/components/mixins/stringHelper"
import { vSelect } from "vue-select";

import { LiftLinkFormType, ILiftLinkForm } from "../../../Types";
import { LiftLinkService } from "@/services/LiftLinkService";

export default {
  props: {
    subscriptionOptions: {
      type: Array,
      required: true
    },
    formData: {
      type: ILiftLinkForm,
      required: false
    },
    liftLinkConfiguration: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      DealerContactEmail: '',
      CustomerEmail: '',
      CustomerName: '',
      selectedSubscriptionOption: '',
      additionalComments: '',
      liftLinkFormType: LiftLinkFormType.RetroFitForm,
      customerContactName: "",
      customerPhoneNumber: "",
      dealerSalesRepEmail: '',
      billingContactEmail: '',
      billingSubscriptionOption: '',
      billingSubscriptionCountry: 'United States',
      billingSubscriptionCountries: [
        'Canada',
        'United States',
        'Mexico'
      ],
      wifiAcknowledged: false
    };
  },
  mixins: [stringHelper],
  computed: {
    ...mapGetters(["user", "getContentItem", "tenantDetails"]),

    billingSubscriptionOptions() {
      if (this.isUSA_USA_USA_USA) {
        return ['Dealer', 'Customer'];
      }
      return ['Dealer'];
    },

    isFormValid() {
      return this.DealerContactEmail !== '' 
      && this.isEmailValid(this.DealerContactEmail)
      && this.CustomerName !== ""
      && this.isEmailValid(this.dealerSalesRepEmail)
      && (this.isEmailValid(this.billingContactEmail) || this.billingSubscriptionOption == "Dealer")
      && this.billingSubscriptionOption !== ""
      && this.wifiAcknowledged;
    },

    // Don't think of them as humans, think of them as... well, Americans
    isUSA_USA_USA_USA() {
      return this.billingSubscriptionCountry === 'United States';
    },

    showBillingContactEmail() {
      return this.billingSubscriptionOption === 'Customer';
    } 
  },
  watch: {
    billingSubscriptionCountry(newCountry) {
      if (newCountry !== 'United States' && this.billingSubscriptionOption === 'Customer') {
        this.billingSubscriptionOption = 'Dealer';
        this.updateLiftLinkFormContext();
      }
    }
  },
  created() {
    this.DealerContactEmail = this.user.Email;
    if (this.formData) {
      this.DealerContactEmail = this.formData.DealerContactEmail;
      this.CustomerEmail = this.formData.CustomerEmail;
      this.CustomerName = this.formData.CustomerName;
      this.selectedSubscriptionOption = this.formData.selectedSubscriptionOption;
      this.additionalComments = this.formData.additionalComments;
      this.customerPhoneNumber = this.formData.customerPhoneNumber;
      this.customerContactName = this.formData.customerContactName;
      this.dealerSalesRepEmail = this.formData.dealerSalesRepEmail || '';
      this.billingContactEmail = this.formData.billingContactEmail || '';
      this.billingSubscriptionOption = this.formData.billingSubscriptionOption || '';
      this.wifiAcknowledged = this.formData.wifiAcknowledged || false;
    }
    this.updateLiftLinkFormContext(); 
  },
  methods: {
    updateLiftLinkFormContext() {
      if (this.isFormValid) {
        const formData = {
          DealerContactEmail: this.DealerContactEmail,
          CustomerEmail: this.CustomerEmail,
          CustomerName: this.CustomerName,
          selectedSubscriptionOption: this.selectedSubscriptionOption,
          additionalComments: this.additionalComments,
          submissionType: this.liftLinkFormType,
          customerContactName: this.customerContactName,
          customerPhoneNumber: this.customerPhoneNumber,
          dealerSalesRepEmail: this.dealerSalesRepEmail,
          billingContactEmail: this.billingContactEmail,
          billingSubscriptionOption: this.billingSubscriptionOption,
          wifiAcknowledged: this.wifiAcknowledged
        };
        this.$emit('formSubmitted', formData);
      } else {
        this.$emit('formInvalid');
      }
    },
  }
};